export default "__VITE_ASSET__BWlPLvFu__"